/* Tracking Event Report Data Service
 *
 * Angular module: trackerbase-app.services.tracking-report-service
 * Exported service: TrackingEventReportData
 */

import angular from "angular";
import ngResource from "angular-resource";

import Assert from "tbAssert";

import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";
import TrackingEventFactoriesModule from "../models/factories/tracking-event-factories";

function TrackingEventReportDataServiceFactory (
    $resource,
    TbAppConfigDataService,
    TrackingEventReportFactory
)
{
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

    const tbServerBaseUrl = TbAppConfigDataService.tbServerBaseUrl;

    const trackingEventReportApiUrl = `${tbServerBaseUrl}/api/trackingevents/:eventId/trackingreport`;
    const trackingEventReportApiParams = { eventId: "@eventId" };


    return $resource(
        trackingEventReportApiUrl,
        trackingEventReportApiParams,
        {
            get: {
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: (serverResponse) => {

                        let serverTrackingEventReport =
                            TrackingEventReportFactory
                                .FromServerTrackingEventReport(
                                    serverResponse.data
                                );

                        angular.extend(serverResponse.resource, {
                            result: serverTrackingEventReport
                        });

                        return serverResponse.resource;
                    }
                }
            }
        }
    );
}

TrackingEventReportDataServiceFactory.$inject = [
    "$resource",
    "TbAppConfigDataService",
    "TrackingEventReportFactory"
];

export default angular
    .module("trackerbase-app.services.tracking-report-service", [
        ngResource,
        TbAppConfigDataServiceModule,
        TrackingEventFactoriesModule
    ])
    .factory("TrackingEventReportData", TrackingEventReportDataServiceFactory)
    .name;
    


//////////////////
// WEBPACK FOOTER
// ./src/services/TrackingEventReportDataService.js
// module id = WWaQ
// module chunks = 1